var map = {
	"./douyin1/1.png": 4975,
	"./douyin1/2.png": 2516,
	"./douyin1/3.png": 3645,
	"./douyin1/4.png": 850,
	"./douyin1/5.png": 4507,
	"./douyin1/6.png": 9104,
	"./kuaishou1/1.png": 8410,
	"./kuaishou1/2.png": 9489,
	"./kuaishou1/3.png": 8360,
	"./kuaishou1/4.png": 503,
	"./xiaohongshu1/1.png": 4952,
	"./xiaohongshu1/2.png": 563,
	"./xiaohongshu1/3.png": 8650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9259;